import { Component } from '@angular/core';
import { BaseDirective } from 'src/app/directives/base.directive';


@Component({
  selector: 'app-wall',
  templateUrl: './wall.component.html',
  styleUrls: ['./wall.component.sass']
})
export class WallComponent extends BaseDirective {
  override title = 'MENU.WALLS';
}
